<template>
  <span class="motivationMessage text-white ml-auto mb-auto text-right">
    {{message}}
</span>
</template>

<script>
  import { getMotivationalMessage } from '../services'

  export default {
    data(){
      return {
        message: ""
      }
    },
    mounted(){
      getMotivationalMessage().then((data)=>{
        this.message = data
      })
    },
  }
</script>
